import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

import { ENV } from '../config/env.js';

/**
 * Build MSAL configuration. We use redirect flow by default (works in
 * tabs/windows); popup flow is the documented fallback for embedded
 * scenarios (VS Code webviews, iframes).
 */
export function buildMsalConfig(): Configuration {
  return {
    auth: {
      clientId: ENV.clientId,
      authority: `https://login.microsoftonline.com/${ENV.tenantId}`,
      redirectUri: ENV.redirectUri,
      postLogoutRedirectUri: ENV.redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
}

let instance: PublicClientApplication | null = null;

export function getMsalInstance(): PublicClientApplication {
  instance ??= new PublicClientApplication(buildMsalConfig());
  return instance;
}
